import { mapValueToMoneyFormat } from 'utils';

export const MAX_RANGE_VAL = 50000000;

export type RangeOptionsCopies = {
  UNDER_MIN: string;
  BETWEEN_VALUES: string;
  ABOVE_MAX: string;
};

export const translateInputToSelectValues = (
  from: string | number,
  to: string | number,
  minSelectValue: number,
  maxSelectValue: number,
  rangeCopies: RangeOptionsCopies,
) =>
  +from === maxSelectValue
    ? rangeCopies.ABOVE_MAX
    : +from === minSelectValue && +to === maxSelectValue
    ? rangeCopies.BETWEEN_VALUES
    : +to === minSelectValue
    ? rangeCopies.UNDER_MIN
    : '';

export const createText = (from: number | string, to: number | string) =>
  from && to
    ? `${mapValueToMoneyFormat(+from)}-${mapValueToMoneyFormat(to)}`
    : from
    ? `Above ${mapValueToMoneyFormat(+from)}`
    : `Under ${mapValueToMoneyFormat(+to)}`;
